module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/home/changepassword/changepassword.component.scss
// module id = ./src/app/pages/home/changepassword/changepassword.component.scss
// module chunks = main